<template>
  <div class="selectStorageStyle">
    <v-select
      v-model="inputedValue"
      item-text="label"
      item-value="value"
      :items="items"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      :height="height"
    >
    </v-select>
  </div>
</template>

<script>
import { stockMoveUtil } from '@/util'
export default {
  components: {
    //
  },
  props: {
    value: {
      type: Object,
      require: false,
      default: () => ({
        start: '',
        end: ''
      })
    },
    height: { default: '32px' }
  },
  data: () => ({
    items: []
  }),
  async created() {
    const isHideUnusedStorageMoveReason = true
    const tmp = await stockMoveUtil.getStorageIdNameList(
      isHideUnusedStorageMoveReason
    )
    if (tmp) {
      this.items = tmp.data
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.selectStorageStyle {
  width: 100%;
}
</style>
